import type { StepNodeData } from '../graph/workflowToGraph';

/**
 * What each kind of declared step is called wherever a workflow is read: on its
 * card, in the workflow page's panel and in the board's prompt dialog (spec 281).
 */
export const STEP_KIND_LABEL: Record<StepNodeData['stepType'], string> = {
  ai_step: 'AI Step',
  human_gate: 'Human Gate',
  linked_workflow: 'Sub workflow',
};

/** A Human Gate's mode as the read-only views say it. */
export const GATE_MODE_LABEL: Record<string, string> = {
  always_human: 'Always human',
  ai_or_human: 'AI or human',
};
